var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"scroll-text-gradient"},[_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"gradient-text",style:(_vm.getTextStyles())},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }